export default __webpack_public_path__ + "media/images/theme_apple/whiteButton-fc8e42da3b9dfe789f68c21e689cfbab.png";